export default "__VITE_ASSET__BwttrgsI__"